const DAYS_OFF = [
  "2024-07-04",
  "2024-09-02",
  "2024-11-28",
  "2024-12-25",
  "2025-01-01",
  "2025-05-26",
  "2025-07-04",
  "2025-09-01",
  "2025-11-27",
  "2025-12-25",
  "2026-01-01",
  "2026-05-25",
  "2026-07-04",
  "2026-09-07",
  "2026-11-26",
  "2026-12-25",
  "2027-01-01",
  "2027-05-31",
  "2027-07-04",
  "2027-09-06",
  "2027-11-25",
  "2027-12-25",
  "2028-01-01",
  "2028-05-29",
  "2028-07-04",
  "2028-09-04",
  "2028-11-23",
  "2028-12-25",
  "2029-01-01",
  "2029-05-28",
  "2029-07-04",
  "2029-09-03",
  "2029-11-22",
  "2029-12-25",
];

export { DAYS_OFF }